/**
 * File navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */
export const navigation = () => {
  const header = document.querySelector('.site-header')
  const siteNavigation = document.getElementById('site-navigation')

  // Return early if the navigation doesn't exist.
  if (!siteNavigation) {
    return
  }

  const button = header.querySelector('.menu-toggle')

  // Return early if the button doesn't exist.
  if ('undefined' === typeof button) {
    return
  }

  const menu = siteNavigation.getElementsByTagName('ul')[0]

  // Hide menu toggle button if menu is empty and return early.
  if ('undefined' === typeof menu) {
    button.style.display = 'none'
    return
  }

  if (!menu.classList.contains('nav-menu')) {
    menu.classList.add('nav-menu')
  }

  const main = document.querySelector('main')
  if (main.classList.contains('allerease-post')) {
    const understanding = menu.querySelector(
      'a[href*="understanding-allergies"]',
    )

    if (understanding) {
      understanding.parentNode.classList.add('current-menu-ancestor')
    }
  }

  if (location.pathname.replace(/\//g, '') === 'find-allerease-products') {
    const shop = document.querySelector('.main-navigation > .button')
    if (shop) {
      shop.classList.add('active')
    }
  }

  const parents = Array.from(menu.children)
  parents.forEach((item) => {
    if (item.classList.contains('menu-item-has-children')) {
      const childrenToggle = document.createElement('button')
      childrenToggle.classList.add('children-toggle')
      childrenToggle.textContent = 'Toggle Children'

      item.querySelector('a').after(childrenToggle)

      childrenToggle.addEventListener('click', () => {
        childrenToggle.classList.toggle('open')
        jQuery(item.querySelector('ul')).slideToggle(400)
      })
    }
  })

  // Toggle the .toggled class and the aria-expanded value each time the button is clicked.
  button.addEventListener('click', function () {
    header.classList.toggle('static')
    button.classList.toggle('toggled')
    siteNavigation.classList.toggle('toggled')
    jQuery(siteNavigation).slideToggle(400)

    if (button.getAttribute('aria-expanded') === 'true') {
      button.setAttribute('aria-expanded', 'false')
    } else {
      button.setAttribute('aria-expanded', 'true')
    }
  })

  // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
  document.addEventListener('click', function (event) {
    const isClickInside = header.contains(event.target)

    if (!isClickInside) {
      siteNavigation.classList.remove('toggled')
      button.setAttribute('aria-expanded', 'false')
    }
  })

  // Get all the link elements within the menu.
  const links = menu.getElementsByTagName('a')

  // Get all the link elements with children within the menu.
  const linksWithChildren = menu.querySelectorAll(
    '.menu-item-has-children > a, .page_item_has_children > a',
  )

  // Toggle focus each time a menu link is focused or blurred.
  for (const link of links) {
    link.addEventListener('focus', toggleFocus, true)
    link.addEventListener('blur', toggleFocus, true)
  }

  // Toggle focus each time a menu link with children receive a touch event.
  // for (const link of linksWithChildren) {
  //   console.log('hello')
  //   link.addEventListener('touchstart', toggleFocus, false)
  // }

  // show/hide nav based on scroll direction
  let lastScrollTop = 0

  const adminBar = document.getElementById('wpadminbar')

  if (adminBar) {
    header.style.top = `${adminBar.offsetHeight}px`
  }

  window.addEventListener('resize', () => {
    if (adminBar) {
      header.style.top = `${adminBar.offsetHeight}px`
    }
  })

  window.addEventListener(
    'scroll',
    () => {
      const headerHeight = header.offsetHeight
      const scrolled = window.pageYOffset || document.documentElement.scrollTop

      if (window.pageYOffset < headerHeight) {
        header.classList.remove('hide')
      } else if (scrolled > lastScrollTop) {
        header.classList.add('hide')
      } else {
        header.classList.remove('hide')
      }

      lastScrollTop = scrolled <= 0 ? 0 : scrolled
    },
    false,
  )

  /**
   * Sets or removes .focus class on an element.
   */
  function toggleFocus() {
    if (event.type === 'focus' || event.type === 'blur') {
      let self = this
      // Move up through the ancestors of the current link until we hit .nav-menu.
      while (!self.classList.contains('nav-menu')) {
        // On li elements toggle the class .focus.
        if ('li' === self.tagName.toLowerCase()) {
          self.classList.toggle('focus')
        }
        self = self.parentNode
      }
    }

    if (event.type === 'touchstart') {
      const menuItem = this.parentNode
      event.preventDefault()
      for (const link of menuItem.parentNode.children) {
        if (menuItem !== link) {
          link.classList.remove('focus')
        }
      }
      menuItem.classList.toggle('focus')
    }
  }
}
